export const MSG_TYPE = [
  {
    label: '只读文本',
    value: '只读文本'
  },
  {
    label: '输入框',
    value: '输入框'
  }
];

export const IS_TRUE = [
  {
    label: '是',
    value: true
  },
  {
    label: '否',
    value: false
  }
];

export const IS_ECHO = [
  {
    label: '是',
    value: 1
  },
  {
    label: '否',
    value: 0
  }
];
